<template>
  <b-container fluid>
    <h3 class="mt-5">
      {{ $t("배송조회") }}
    </h3>
    <div class="alert alert-info">송장번호 {{ $route.params.tnum }}</div>
    <div
      v-if="$route.params.tnum.slice(0, 3) === 'EXT'"
      class="alert alert-warning"
    >
      <a
        target="_blank"
        :href="'http://wegohan.com/popup/multiList/' + $route.params.tnum"
        >복수 운송장 확인 링크
      </a>
    </div>
    <h5 class="mt-3">
      {{ $t("국내배송상황안내") }}
    </h5>
    <div>
      국내배송은 배송사는 현재 롯데택배입니다. 배송조회링크:
      <a
        target="_blank"
        :href="
          'https://www.lotteglogis.com/mobile/reservation/tracking/linkView?InvNo=' +
          $route.params.tnum
        "
        >https://www.lotteglogis.com/mobile/reservation/tracking/linkView?InvNo={{
          $route.params.tnum
        }}</a
      >
    </div>
    <table class="table table-responsive-sm domestic">
      <tbody v-for="data in fetch.domesticData" :key="data.time">
        <tr>
          <td>{{ data.location }}</td>
          <td>{{ data.time }}</td>
          <td>{{ data.status }}</td>
          <td>{{ data.desc }}</td>
        </tr>
      </tbody>
    </table>
    <div align="center" v-show="fetch.domesticData.length === 0">
      <b-badge variant="info">로딩중입니다...</b-badge>
    </div>
    <h5 class="mt-5">
      {{ $t("통관상황안내") }}
    </h5>
    <div>
      <div v-if="carrier === 'ibk'">
        관세사 연락처(중국발): 032-889-0093 제일관세사
      </div>
      <div v-else-if="carrier === 'gsi'">
        관세사 연락처(미국발/GSI): 070-5213-2987 대교 관세사 배기혁 팀장
      </div>
      <div v-else-if="carrier === 'gwn'">
        관세사 연락처(미국발/다다스마트): 통관관련 - CNI관세사 070-4333-5630,
        국내택배 관련 - 스마트로지스 이동현 과장 E-Mail : ldh@smartlogis.kr, TEL
        031-312-9550
      </div>
    </div>
    <div class="grid_list">
      <table
        id="MYC0405102Q_resultListL"
        class="JColResizer table table-responsive-sm"
      >
        <thead>
          <tr class="header">
            <th scope="col" data-number="" rowspan="2">No</th>
            <th scope="col">처리단계</th>
            <th scope="col">장치장/장치위치</th>
            <th scope="col">포장개수</th>
            <th scope="col">반출입(처리)일시</th>
            <th scope="col">신고번호</th>
          </tr>
          <tr class="header">
            <th scope="col">처리일시</th>
            <th scope="col">장치장명</th>
            <th scope="col">중량</th>
            <th scope="col">반출입(처리)내용</th>
            <th scope="col">반출입근거번호</th>
          </tr>
        </thead>
        <tbody v-for="data in fetch.customData.records" :key="data.rowNo">
          <tr class="">
            <td rowspan="3">{{ data.rowNo }}</td>
            <td v-html="data.rlbrCn"></td>
            <td class="textLeft" name="snarSgn" v-html="data.shedNm"></td>
            <td class="textRight" name="cmdtGcnt">{{ data.pckGcnt }}</td>
            <td>{{ data.rlbrDttm }}</td>
            <td name="brngBssNo">{{ data.dclrNo }}</td>
          </tr>
          <tr class="">
            <td data-customformat="cf_formatDateTime" class="mycMerge">
              {{ timeFormat(data.prcsDttm) }}
            </td>
            <td class="textLeft mycMerge" name="snarKoreNm">
              {{ data.shedNm }}
            </td>
            <td class="textRight mycMerge" name="cmdtWght">
              {{ data.wght ? data.wght + "KG" : "" }}
            </td>
            <td name="prcsCn" class="mycMerge">
              {{ data.cargTrcnRelaBsopTpcd }}
            </td>
            <td name="rlbrBssNo" class="mycMerge">{{ data.shedSgn }}</td>
          </tr>
          <tr name="mycMergeTr" class="" v-if="data.bfhnGdncCn">
            <td colspan="5" name="comment">{{ data.bfhnGdncCn }}</td>
          </tr>
        </tbody>
      </table>
      <div align="center" v-show="fetch.customData.records.length === 0">
        <!--        <b-badge variant="info">로딩중입니다...</b-badge>-->
      </div>
    </div>
    <h5 class="mt-5">
      {{ $t("국제배송상황안내") }}
    </h5>
    <table class="table table-responsive-sm">
      <thead>
        <tr>
          <th>단계</th>
          <th>처리일시</th>
          <th>화물상태</th>
          <th>위치</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="fetch.shipday && dateArrived">
          <td>선적</td>
          <td>{{ timeFormat(dateArrived) }}</td>
          <td>고객님의 상품이 한국으로 이동중입니다.</td>
          <td>산동</td>
        </tr>
        <tr v-if="fetch.shipday">
          <td>출고</td>
          <td>{{ $showTime(fetch.shipday) }}</td>
          <td>고객님의 상품이 항만 또는 공항으로 이동중입니다.</td>
          <td>상해</td>
        </tr>
      </tbody>
    </table>
  </b-container>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import moment from "moment-timezone";

export default {
  name: "home",
  components: {
    HelloWorld,
  },
  data() {
    return {
      carrier: "",
      items: [],
      fetch: {
        customData: {
          records: [],
          info: {},
        },
        domesticData: [],
        scanday: "",
      },
      dateArrived: "",
    };
  },
  methods: {
    timeFormat(time) {
      return time.replace(
        /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/,
        "$1-$2-$3 $4:$5:$6",
      );
    },
    $showTime(time, option) {
      if (time)
        return moment(time)
          .tz("Asia/Seoul")
          .format(option ? option : "L LTS");
    },

    async fetchData() {
      let fetch = await this.$get("/track/" + this.$route.params.tnum);
      this.fetch.domesticData = fetch.domesticData;
      this.fetch.shipday = fetch.shipday;
      this.fetch.customData = await this.$get(
        `https://api.resell.glocing.com/track/${
          this.$route.params.tnum
        }/customs/${this.$route.params.year ? this.$route.params.year : ""}`,
      );
      const customRecords = this.fetch.customData.records;
      this.fetch.customData.records.forEach((record) => {
        record = JSON.stringify(record);
        if (record.includes("에이씨이익스프레스")) this.carrier = "gsi";
        else if (record.includes("스마트로지스")) this.carrier = "gwn";
        else if (record.includes("인천세관 제2지정장치장"))
          this.carrier = "ibk";
      });
      if (customRecords.length > 0) {
        this.dateArrived = customRecords[customRecords.length - 1].prcsDttm;
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
<style scoped>
@media only screen and (max-width: 600px) {
  .domestic th:nth-child(3) {
    display: none;
  }
}
</style>
